import { render, staticRenderFns } from "./WDAvatarPreview.vue?vue&type=template&id=36deca1c&"
import script from "./WDAvatarPreview.vue?vue&type=script&lang=js&"
export * from "./WDAvatarPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports